<template>
  <div class="modal-cover" @click="onClose" v-if="!isLeaved">
    <div class="attendance-container" @click.stop>
      <div class="attendance-header-container">
        <button class="close-modal" @click="onClose"></button>
        <div>{{ $t('camstudy.attendance.title') }}</div>
        <div class="attendance-expand-container" @click="selectAll">
          <div class="attendance-expand" :class="{open: expandAll}">
            {{ expandAll ? $t('camstudy.attendance.closeAll') : $t('camstudy.attendance.expandAll') }}
          </div>
        </div>
      </div>
      <ul class="attendance-body-container">
        <li class="attendance-user-item" @click="onSelectUser(cu)"
            v-for="cu in attendanceUserList" :key="`attendance-`+cu.userId"
        >
          <div class="attendance-item-container">
            <div class="attendance-list-item flex justify-between items-center w-full">
              <div class="flex overflow-hidden mr-2">
                <div class="v-name-img">
                  <UserProfileImage :user-id="cu.userId" class="profile-image"/>
                  <GrmIcon icon=""
                           v-if="hasEmceeRole(cu.userId)"
                           :class="hasSpeakerRole(cu.userId) ? 'room-speaker' : 'room-emcee'"
                  />
                </div>
<!--                <img v-if="cu.profileImageUrl" class="user-image" :src="cu.profileImageUrl" alt="user">-->
<!--                <div v-else class="user-image none"></div>-->
                <div class="user-name">{{cu.username}}</div>
              </div>
              <div class="flex gap-2 items-center flex-shrink-0">
                <template v-if="camStudy?.usePoint">
                  <div>{{ $t('camstudy.attendance.score') }}</div>
                  <button v-if="selected(cu.userId) && hasEmceeRole()" class="minus-score" @click.stop="addPoint(cu.userId, -1, cu.point+cu.pPoint)"></button>
                  <div>{{cu.point + cu.pPoint}}</div>
                  <button v-if="selected(cu.userId) && hasEmceeRole()" class="plus-score" @click.stop="addPoint(cu.userId, 1, cu.point+cu.pPoint)"></button>
                </template>
                <button class="attendance-list-item-btn" :alt="$t('common.arrow')" :class="{active: selected(cu.userId)}">
                  <img class="arrow-image" src="@/assets/images/arrowLineDown_white.svg" />
                </button>
              </div>
            </div>
            <div class="attendance-user-detail" v-if="selected(cu.userId)">
              <div class="detail-container">
                <div class="title">Email</div>
                <div class="content">&nbsp;{{selectedUser(cu.userId).email}}</div>
              </div>
              <div class="detail-container">
                <div class="title">{{ $t('camstudy.attendance.recentAttendance') }}</div>
                <div class="content">&nbsp;{{selectedUser(cu.userId).attendDate}}</div>
              </div>
              <div class="detail-container">
                <div class="title">{{ $t('camstudy.attendance.recentStudyTime') }}</div>
                <div class="content">&nbsp;{{selectedUser(cu.userId).recentStudyTime}}</div>
              </div>
              <div class="detail-container">
                <div class="title">{{ $t('camstudy.attendance.totalStudyTime') }}</div>
                <div class="content">&nbsp;{{selectedUser(cu.userId).totalStudyTime}}</div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import moment from "moment/moment";
import UserProfileImage from "@/components/Room/User/UserProfileImage.vue";
import GrmIcon from "@/components/Common/icon/GrmIcon.vue";

export default {
  name: "CamstudyAttendanceModal",
  components: {GrmIcon, UserProfileImage},
  data(){
    return {
      expandAll: false,
      selectedList: [],
    }
  },
  computed: {
    ...mapGetters('room', [
      'isLeaved',
      'isOpen'
    ]),
    ...mapGetters('user', [
        'hasEmceeRole',
        'hasSpeakerRole',
        'isMe'
    ]),
    ...mapGetters('camstudy', [
        'enteredCamStudyUserList',
        'camStudyUserList',
        'getUserStudyData',
        'camStudy',
        'camStudyUserList',
    ]),
    attendanceUserList() {
      return this.isOpen ? this.enteredCamStudyUserList : this.camStudyUserList
    },
    selected() {
      return (userId) => {
        return this.selectedList.findIndex(user => user.userId === userId) > -1
      }
    },
    selectedUser() {
      return (userId) => {
        return this.selectedList.find(user => user.userId === userId)
      }
    }
  },
  methods: {
    ...mapActions('camstudy', [
        'addCamStudyUserPoint'
    ]),
    formatTime(seconds) {
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const secs = seconds % 60;

      const paddedHours = hours.toString().padStart(2, '0');
      const paddedMinutes = minutes.toString().padStart(2, '0');
      const paddedSeconds = secs.toString().padStart(2, '0');

      return `${paddedHours}:${paddedMinutes}:${paddedSeconds}`;
    },
    formatDate(date) {
      return moment(date).format('YYYY-MM-DD HH:mm:ss');
    },
    maskEmail(email) {
      if(!email) return
      return email.replace(/^(.)(.*)(.@.*)$/, (match, firstChar, middleChars, lastPart) => {
        const maskedMiddle = middleChars.replace(/./g, '*');
        return firstChar + maskedMiddle + lastPart;
      });
    },
    onClose() {
      this.$modal('CamstudyAttendanceModal', {once: true})
    },
    onSelectUser(user, all = false) {
      if(!user) return
      if(!all && this.selected(user.userId)) {
        this.deSelectUser(user.userId)
        return
      }
      let su = this.selectedUser(user.userId)
      if(!su) {
        su = {userId : user.userId}
        this.selectedList.push(su)
      }

      su.email = this.maskEmail(user.email)
      su.totalStudyTime = this.formatTime(user.time || 0)
      const studyData = this.getUserStudyData(user.userId)
      su.attendDate = this.formatDate(studyData?.regDate)
      su.recentStudyTime = this.formatTime(studyData?.time || 0)

      if(!all && this.checkSelectedAll()) {
        this.expandAll = true
      }
    },
    deSelectUser(userId, all = false) {
      const index = this.selectedList.findIndex(user => user.userId === userId)
      if(index !== -1) {
        this.selectedList.splice(index, 1)
      }

      if(!all && this.selectedList.length === 0) {
        this.expandAll = false
      }
    },
    selectAll() {
      this.expandAll=!this.expandAll
      if(this.expandAll) {
        this.attendanceUserList.forEach(cu => {
          this.onSelectUser(cu, true)
        })
      } else {
        this.attendanceUserList.forEach(cu => {
          this.deSelectUser(cu.userId, true)
        })
      }
    },
    checkSelectedAll() {
      const userIds = new Set(this.attendanceUserList.map(user => user.userId))

      return this.selectedList.length >= userIds.size && this.selectedList.every(selected => userIds.has(selected.userId))
    },
    addPoint(userId, point, totalPoint) {
      if(!this.hasEmceeRole()) return

      if(!(totalPoint < -99 && point < 0) && !(totalPoint > 99 && point > 0)) {
        clearTimeout(this._point_timer);
        this._point_timer = setTimeout(() => {
          this.addCamStudyUserPoint({userId, penalty: point < 0, point});
        }, 100);
      }
    },

  }
}
</script>

<style scoped lang="scss">
[grm-device-mobile] {
  background-color: rgba(0, 0, 0, 0.5);
  .modal-cover {
    @media(orientation: portrait) {
      left: 0;
      right: 0;
      bottom: 64px;
    }
    @media(orientation: landscape) {
      left: env(safe-area-inset-left);
      right: env(safe-area-inset-right);
      bottom: 98px;
      z-index: 99;
    }
    .attendance-container{
      @media(orientation: portrait) {
        bottom: 0;
        left: 0;
        width: 100%;

        .attendance-body-container {
          height: 331px;
        }
      }
      @media(orientation: landscape) {
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;

        .attendance-body-container {
          height: calc(100% - 44px);
        }
      }
    }
  }
}
html:not([grm-device-mobile]) {
  .modal-cover {
    left: 0;
    right: 0;
    bottom: 80px;
    top: 0;

    .attendance-container{
      bottom: -80px;
      top: 0;
      right: 0;
      width: 360px;
      border-left: 0.5px solid rgba(255, 255, 255, 0.20);
      background: #1A1A1A;

      .attendance-body-container {
        height: calc(100% - 44px);
      }
    }
  }
}
.modal-cover {
  position: fixed;
  top: 0;
  z-index: 2;
}

.attendance-container {
  position: absolute;
  background: #1F1F1F;
  color: white;
  z-index: 2;

  .attendance-header-container {
    position: relative;
    display: flex;
    height: 44px;
    padding: 6px 16px;
    justify-content: center;
    align-items: center;
    font-size: 14px;

    .attendance-expand-container{
      position: absolute;
      right: 16px;
      top: 6px;

      padding: 5px 4px;
    }
    .attendance-expand {
      border-radius: 6px;
      background: #393939;
      padding: 4px 8px;
      color: #FFF;
      font-size: 12px;
      line-height: 14px;
    }
  }

  .attendance-body-container{
    padding: 12px 0;
    overflow-y: scroll;
    &::-webkit-scrollbar {
      display: none;
    }

    .attendance-user-item{
    }

    .user-image{
      width: 24px;
      height: 24px;
      border-radius: 12px;
      margin-right: 12px;

      &.none {
        background: url("~@/assets/images/user_profile.svg") no-repeat;
        background-size: auto 24px;
      }
    }
    .user-name{
      font-size: 14px;
      display: flex;
      align-items: center;
      text-wrap: nowrap;
      margin-left: 8px;
    }
  }

  .attendance-item-container {
    padding: 0;

    .attendance-list-item {
      padding: 12px 16px;
      font-size: 14px;

      .v-name-img {
        position: relative;
        width: 28px;
        height: 28px;

        .profile-image {
          width: 80%;
          height: 80%;
          border-radius: 100%;
          overflow: hidden;
        }

        .room-speaker {
          position: absolute;
          right: 0;
          bottom: 0;
          width: 14px;
          height: 14px;
          border-radius: 6px;
          background: #FF7F00 url('~@/assets/images/crown_white.svg') no-repeat center / auto 72%;
          // background: white url('~@/assets/images/crown_blue.svg') no-repeat center / auto 80%;
          box-sizing: content-box;
          border: 2px solid #1F1F1F;
        }
        .room-emcee {
          position: absolute;
          right: 0;
          bottom: 0;
          width: 14px;
          height: 14px;
          border-radius: 6px;
          background: #666666 url('~@/assets/images/crown_white.svg') no-repeat center / auto 72%;
          // background: white url('~@/assets/images/crown_blue.svg') no-repeat center / auto 80%;
          box-sizing: content-box;
          border: 2px solid #1F1F1F;
        }
      }

      .attendance-list-item-btn {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 32px;
        height: 32px;

        &.active .arrow-image {
          transform: rotate(180deg);
        } 
      }
      
      .arrow-image {
        width: 12px;
        height: 12px;
      }             
    }
  }

  .close-modal{
    position: absolute;
    top: 6px;
    left: 16px;
    width: 32px;
    height: 32px;
    background: url("~@/assets/images/camstudy/ico_close_white.svg") center no-repeat;
    background-size: auto 24px;
  }
  .attendance-icon{
    width: 24px;
    height: 24px;
    background: url("~@/assets/images/camstudy/ico_attendance_white.svg") center no-repeat;
  }
  .minus-score{
    width: 18px;
    height: 18px;
    background: url("~@/assets/images/camstudy/ico_attendance_minus.svg") center center no-repeat;
  }
  .plus-score{
    width: 18px;
    height: 18px;
    background: url("~@/assets/images/camstudy/ico_attendance_plus.svg") center center no-repeat;
  }

  .attendance-user-detail{
    background: #141414;
    padding: 12px 20px;

    .detail-container {
      display: flex;

      .title {
        font-size: 12px;
        font-weight: 700;
        line-height: 150%;
      }

      .content {
        font-size: 12px;
        line-height: 150%;
      }
    }
  }
}

</style>